import React, { useState, useMemo } from 'react';
import { Tooltip } from 'antd';
import lodashGet from 'lodash/get';
import { FolderTreeEditState, getIn18Text } from 'api';
import { isObject } from 'lodash';
import IconCard from '@web-common/components/UI/IconCard';
import { folderId2String, folderId2Number } from '../../util';
import { FLOLDER } from '../../common/constant';
import useState2RM from '../../hooks/useState2ReduxMock';
import Tree from '../../common/library/Tree';
import useThrottleForEvent from '../../hooks/useThrottleForEvent';
const SearchResultTree = props => {
    const { data, email, handleSwitchFolder, expandFolder } = props;
    const [showDataKeys, setShowDataKeys] = useState([]);
    const [selectedSearchKeys, setSelectedSearchKeys] = useState2RM('selectedSearchKeys', 'doUpdateSelectedSearchKey');
    const [mailSearchFolderIds, setMailSearchFolderIds] = useState2RM('mailSearchFolderIds', 'doUpdateMailSearchFolderIds');
    const [defaultSelectedSearchKeyMap, doUpdateDefaultSelectedSearchKeyMap] = useState2RM('defaultSelectedSearchKeyMap', 'doUpdateDefaultSelectedSearchKeyMap');
    const [expandedSearchKeys, setExpandedSearchKeys] = useState2RM('expandedSearchKeys', 'doUpdateExpandedSearchKeys');
    const [listLoading] = useState2RM('listLoading', 'doUpdateMailListLoading');
    const [mailSearching] = useState2RM('mailSearching', 'doUpdateMailSearching');
    const isAdvancedSearch = useMemo(() => mailSearching === 'advanced', [mailSearching]);
    const renderSearchTreeNodeTitle = (node, innerExpandedKeys) => {
        const showName = (node === null || node === void 0 ? void 0 : node._state) == FolderTreeEditState.DEFAULT || !(node === null || node === void 0 ? void 0 : node._state);
        return (React.createElement(Tooltip, { title: showName ? node.mailBoxName : '', placement: "bottom" },
            React.createElement("div", { className: "tree-content-warp" },
                showName ? React.createElement("span", { className: "u-foldername" }, node.mailBoxName) : '',
                React.createElement("span", { className: "u-unread" }, (node.mailBoxId == FLOLDER.DRAFT
                    ? node.mailBoxTotal
                    : node.mailBoxId == FLOLDER.REDFLAG || node.mailBoxId == FLOLDER.DELETED || node.mailBoxId == FLOLDER.SPAM
                        ? '0'
                        : innerExpandedKeys.indexOf(node.mailBoxId) > -1)
                    ? node.mailBoxCurrentUnread
                        ? node.mailBoxCurrentUnread
                        : '0'
                    : node.mailBoxUnread
                        ? node.mailBoxUnread
                        : '0'))));
    };
    const renderSearchStatsNodeTitle = (node) => (React.createElement(Tooltip, { title: node.label, placement: "bottom" },
        React.createElement("div", { className: "tree-content-warp" },
            React.createElement("span", { className: "u-foldername" }, node.label),
            React.createElement("span", { className: "u-unread" }, node.value))));
    const renderSearchTreeData = (data, keys, searchTree = false) => data
        .map(item => {
        var _a;
        const hideNode = searchTree && lodashGet(item, 'entry.mailBoxUnread', 0) === 0;
        return hideNode
            ? null
            : {
                title: () => renderSearchTreeNodeTitle(item.entry, keys),
                key: folderId2String((_a = item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId),
                nodeData: item,
                children: item.children && item.children.length ? renderSearchTreeData(item.children, keys, searchTree) : [],
            };
    })
        .filter(item => item);
    const renderSearchStatsData = (data, parentKey) => {
        const result = [];
        let lastestData = {};
        if (parentKey === 'fromAddress') {
            data.all && (lastestData.all = data.all);
            const values = Object.values(data);
            values.sort((a, b) => {
                const aSort = a.contactLabel || 'Z';
                const bSort = b.contactLabel || 'Z';
                if (aSort < bSort) {
                    return -1;
                }
                if (aSort > bSort) {
                    return 1;
                }
                return 0;
            });
            values.forEach(item => {
                var _a;
                lastestData[(_a = item.filterCond) === null || _a === void 0 ? void 0 : _a.operand] = item;
            });
        }
        else {
            lastestData = data;
        }
        for (const key in lastestData) {
            result.push({
                title: renderSearchStatsNodeTitle(lastestData[key]),
                key,
                nodeData: lastestData[key],
                children: [],
            });
        }
        return result;
    };
    const handleShowDataKeys = (key) => {
        const lastestShowDataKeys = [...showDataKeys];
        lastestShowDataKeys.push(key);
        setShowDataKeys(lastestShowDataKeys);
    };
    const handleHideDataKeys = (key) => {
        const lastestShowDataKeys = [...showDataKeys];
        const pos = lastestShowDataKeys.indexOf(key);
        if (pos > -1) {
            lastestShowDataKeys.splice(pos, 1);
            setShowDataKeys(lastestShowDataKeys);
        }
    };
    const countFolderIds = (list) => {
        var _a;
        const data = [...list];
        const resFlat = [];
        while (data.length) {
            const cur = data.shift();
            if (!cur)
                continue;
            if ((_a = cur.children) === null || _a === void 0 ? void 0 : _a.length) {
                data.push(...cur.children);
            }
            resFlat.push(cur);
        }
        return resFlat.map(item => item.mailBoxId);
    };
    const switchFolder = useThrottleForEvent((node, isFolder, itemKey) => {
        if (listLoading && isAdvancedSearch) {
            return;
        }
        const nodeKey = (isFolder ? folderId2Number(node.key) : node.key) + '';
        let equal = false;
        const clickItem = (selectedSearchKeys[email] && selectedSearchKeys[email][itemKey]) || (defaultSelectedSearchKeyMap[email] && defaultSelectedSearchKeyMap[email][itemKey]);
        if (isObject(clickItem === null || clickItem === void 0 ? void 0 : clickItem.operand)) {
            equal = nodeKey === Object.values(clickItem.operand)[0] + '';
        }
        else if (nodeKey === clickItem || nodeKey === (clickItem === null || clickItem === void 0 ? void 0 : clickItem.operand)) {
            equal = true;
        }
        if (equal) {
            return;
        }
        const nodeData = node === null || node === void 0 ? void 0 : node.nodeData;
        const filterCond = nodeData === null || nodeData === void 0 ? void 0 : nodeData.filterCond;
        setSelectedSearchKeys(Object.assign(Object.assign({}, selectedSearchKeys), { [email]: isFolder
                ? { folder: nodeKey }
                : Object.assign(Object.assign({}, selectedSearchKeys[email]), { [itemKey]: filterCond ? Object.assign({}, filterCond) : nodeKey }) }));
        if ((nodeData === null || nodeData === void 0 ? void 0 : nodeData.entry) && lodashGet(nodeData, 'children.length', 0) > 0) {
            const ids = countFolderIds(nodeData.children);
            setMailSearchFolderIds(ids);
        }
        else if (nodeData === null || nodeData === void 0 ? void 0 : nodeData.entry) {
            setMailSearchFolderIds([]);
        }
        handleSwitchFolder(nodeData);
    }, 500, {
        leading: true,
        trailing: false,
    });
    return (React.createElement("div", { className: "search-result-tree-wrap" }, data.map((item, index) => {
        let treeData = [];
        const itemKey = item.key;
        const isFolder = itemKey === 'folder';
        if (isFolder) {
            treeData = renderSearchTreeData(item.item, expandedSearchKeys, true);
        }
        else {
            treeData = renderSearchStatsData(item.item, itemKey);
        }
        const defaultShowData = treeData.slice(0, 6);
        const defaultHideData = treeData.slice(6);
        const existHideData = defaultHideData.length > 0;
        let currentSelect = selectedSearchKeys[email] && selectedSearchKeys[email][itemKey];
        if (itemKey !== 'folder' && isObject(currentSelect === null || currentSelect === void 0 ? void 0 : currentSelect.operand)) {
            currentSelect = Object.values(currentSelect.operand)[0] + '';
        }
        else if (itemKey !== 'folder') {
            currentSelect = currentSelect === null || currentSelect === void 0 ? void 0 : currentSelect.operand;
        }
        currentSelect = currentSelect || (defaultSelectedSearchKeyMap[email] && defaultSelectedSearchKeyMap[email][itemKey]);
        if (currentSelect && itemKey === 'sentDate') {
            try {
                currentSelect = currentSelect.replace(/[:]+/g, '');
            }
            catch (e) {
                console.error('[Error reg]', e);
            }
        }
        const selectedKeys = currentSelect ? [currentSelect] : [];
        const expandedSearchStrKeys = expandedSearchKeys.map((item) => item + '');
        return (React.createElement("div", { className: "search-result-tree-item", key: index },
            React.createElement("p", { className: "search-result-tree-name" }, item.name),
            React.createElement(Tree, { defaultExpandedKeys: ['-2'], onSelect: (_, { node }) => switchFolder(node, isFolder, itemKey), onExpand: expandFolder, expandedKeys: expandedSearchStrKeys, selectedKeys: selectedKeys, blockNode: true, treeData: defaultShowData }),
            showDataKeys.includes(itemKey) && (React.createElement(Tree, { onSelect: (_, { node }) => switchFolder(node, isFolder, itemKey), onExpand: expandFolder, selectedKeys: selectedKeys, expandedKeys: expandedSearchStrKeys, blockNode: true, treeData: defaultHideData })),
            existHideData && !showDataKeys.includes(itemKey) ? (React.createElement("p", { className: "search-result-tree-more", onClick: () => handleShowDataKeys(itemKey) },
                getIn18Text('GENGDUO'),
                React.createElement(IconCard, { type: "arrowDown" }))) : (''),
            existHideData && showDataKeys.includes(itemKey) ? (React.createElement("p", { className: "search-result-tree-pack", onClick: () => handleHideDataKeys(itemKey) },
                getIn18Text('SHOUQI'),
                React.createElement(IconCard, { type: "arrowUp" }))) : ('')));
    })));
};
export default SearchResultTree;
